
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { DealerFilter } from '../../components/dealer/filter';
import { AllMeta } from '@/components/common/meta';
import Head from "next/head";

export default function Index(props) {
    const { t } = props;
    return (
        <>
            <AllMeta
                title={t('dealerPage_meta_title')}
                description={t('dealerPage_meta_description')}
                keyword={t('dealerPage_meta_keyword')}
            />
            <Head><title>{t('dealerPage_title')}</title></Head>
            <DealerFilter {...props} />
        </>
    )
}

export async function getStaticProps({ locale }) {
    return {
        props: {
        ...(await serverSideTranslations(locale, ['common'])),
        },
    };
}